import React, { Component, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import DashImportacaoModel from "../../../components/classes/DashImportacao";

export default function ChartCause(props: CharCauseProps) {
  const [seriesMixedChart, setSeriesMixedChart] = useState<{ data: number[] }[]>([]);
  const [optionsMixedChart, setOptionsMixedChart] = useState<ApexCharts.ApexOptions>({});

  useEffect(() => {

    var groupedByCausador = props.data?.reduce(function (r, a) {
      r[a.causador] = r[a.causador] || [];
      r[a.causador].push(a);
      return r;
    }, Object.create(null)) ?? [];

    var eixoX: number[] = [];
    var eixoY: string[] = [];
    var groupedByCausadorKeys = Object.keys(groupedByCausador).sort((a, b) => groupedByCausador[b].length - groupedByCausador[a].length);
    groupedByCausadorKeys.forEach(key => {
      var x = groupedByCausador[key];
      eixoX.push(x.length);
      eixoY.push(!key ? 'Sem Causador' : key);
    });

    setSeriesMixedChart([{ data: eixoX }]);

    setOptionsMixedChart({
      chart: {
        id: "chartCause01",
        height: 250,
        type: 'bar'
      },
      plotOptions: {
        bar: {
          barHeight: "80%",
          borderRadius: 3,
          horizontal: true,
          dataLabels: {
            position: "bottom",
          }
        }
      },
      colors: ['#f1d075'],
      dataLabels: {
        enabled: true,
        textAnchor: 'start',
        style: {
          colors: ['#4c4c4c'],
        },
        formatter: function (val, opt) {
          return opt.w.globals.labels[opt.dataPointIndex] + ":   " + val
        },
        offsetX: 0,
      },
      grid: {
        show: false,
      },
      xaxis: {
        type: "category",
        categories: eixoY
      },
      yaxis: {
        labels: {
          show: false
        }
      },
    });

  }, [props])

  return (
    <div id="chartCause01" className="mixed-chart">
      <Chart
        options={optionsMixedChart}
        series={seriesMixedChart}
        type="bar"
        height={250}
        maxWidth={250}
      />
    </div>
  );
}

interface CharCauseProps {
  data?: DashImportacaoModel[]
}